<div class="bg-light px-2 pt-2">
  <div class="row">
    <div class="col-12 col-xl-3 mb-2 mb-xl-0">
      <input
        *ngIf="hasGridSearch"
        type="search"
        class="form-control"
        placeholder="{{ 'SHARED.SEARCH' | translate }}..."
        [(ngModel)]="gridSearchedValue"
        (ngModelChange)="onGridSearch()"
      />
      <app-search
        *ngIf="hasGlobalSearch"
        [globalSearch]="globalSearch"
        [disabled]="disableFilters"
        (searchChange)="onGlobalSearchChange($event)"
        (search)="onGlobalSearchSubmit()"
      ></app-search>
    </div>
    <div class="col-12 col-xl-3 mb-2 mb-xl-0">
      <app-multi-select
        *ngIf="hasColumnSelect"
        [placeholder]="'SHARED.COLUMN'"
        [data]="columnList"
        [(ngModel)]="selectedColumns"
        [itemsShowLimit]="1"
        (select)="onColumnSelect($event)"
        (selectAll)="onAllColumnsSelect($event)"
        (deSelect)="onColumnDeSelect($event)"
        (sortedColumns)="onColumnReorder($event)"
      >
      </app-multi-select>
    </div>
    <div class="col-12 col-xl-6 text-right">
      <ng-container *ngFor="let button of customButtonConfig">
        <button
          *appPermission="button.permission"
          class="btn btn-primary mr-1"
          [disabled]="button.isDisabled() || isLoading(button.isLoading)"
          (click)="button.onClick()"
          [title]="button.title"
        >
          <span *ngIf="isLoading(button.isLoading); else elseBlock">
            <span *ngIf="button.loadingText" class="btn-text" translate>{{
              button.loadingText
            }}</span>
            &nbsp;
            <i class="fa fa-spinner fa-spin"></i>
          </span>
          <ng-template #elseBlock>
            <span>
              <span *ngIf="button.text" class="btn-text" translate>{{ button.text }}</span>
              <i *ngIf="button.iconClass" [ngClass]="button.iconClass"></i>
            </span>
          </ng-template>
        </button>
      </ng-container>
      <button
        type="button"
        class="btn mr-1"
        data-toggle="tooltip"
        data-placement="left"
        title="Column filter"
        *ngIf="hasFloatingFilter"
        [disabled]="disableFilters"
        [style.background-color]="isFloatingFilterEnabled ? '#20a8d8' : '#c8ced3'"
        (click)="onToggleFloatingFilter()"
      >
        <i class="fa fa-filter" [style.color]="isFloatingFilterEnabled ? 'white' : 'black'"></i>
      </button>
      <button
        type="button"
        class="btn btn-primary mr-1"
        data-toggle="tooltip"
        data-placement="left"
        [title]="'SHARED.' + (isAutoSize ? 'FIT_TO_WINDOW' : 'FIT_TO_COLUMN') | translate"
        (click)="onChangeColumnSize()"
      >
        <i class="fa" [ngClass]="isAutoSize ? 'fa-arrows-alt' : 'fa-arrows-h'"></i>
      </button>
      <ng-container *ngIf="addNewUrl">
        <button
          *appPermission="permission"
          type="button"
          class="btn mr-1"
          data-toggle="tooltip"
          data-placement="left"
          title="{{ 'SHARED.ADD_NEW' | translate }}"
          [ngClass]="disableAdd ? 'btn-secondary' : 'btn-primary'"
          [disabled]="disableAdd"
          [routerLink]="disableAdd ? null : addNewUrl"
        >
          <i class="fa fa-plus"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="editUrl">
        <button
          *appPermission="permission"
          type="button"
          class="btn mr-1"
          data-toggle="tooltip"
          data-placement="left"
          title="{{ 'SHARED.EDIT' | translate }}"
          [ngClass]="noOfSelectedRows !== 1 || disableEdit ? 'btn-secondary' : 'btn-primary'"
          [disabled]="noOfSelectedRows !== 1 || disableEdit"
          (click)="onEdit()"
        >
          <i class="fa fa-pencil"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="hasDelete">
        <button
          *appPermission="permission"
          type="button"
          class="btn btn-primary"
          data-toggle="tooltip"
          data-placement="left"
          title="{{ 'SHARED.DELETE' | translate }}"
          [ngClass]="isDeleteDisabled ? 'btn-secondary' : 'btn-primary'"
          [disabled]="isDeleteDisabled"
          (click)="onDelete()"
        >
          <i class="fa fa-trash"></i>
        </button>
      </ng-container>
    </div>
  </div>
</div>
<div class="bg-light p-2">
  <div
    *ngIf="
      rowData && !hasFloatingFilter && !useOverlayNoRowsTemplate && (rowData | async)?.length === 0;
      else grid
    "
  >
    <span *ngIf="noRowsText; else noRecords" translate [innerText]="noRowsText"> </span>
    <ng-template #noRecords><span translate>SHARED.NO_RECORDS</span> </ng-template>
  </div>
  <ng-template #grid>
    <ag-grid-angular
      style="width: 100%"
      class="ag-theme-balham"
      [class.list-grid-hide-pagination]="!hasRows"
      domLayout="autoHeight"
      [rowHeight]="rowHeight"
      [rowData]="rowData | async"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [components]="components"
      [context]="context"
      [suppressRowClickSelection]="suppressRowClickSelection"
      [rowSelection]="'multiple'"
      [rowMultiSelectWithClick]="true"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
      [pagination]="hasPagination"
      [paginationPageSize]="paginationPageSize"
      [singleClickEdit]="true"
      [stopEditingWhenCellsLoseFocus]="true"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
      (columnResized)="onColumnResized($event)"
      (selectionChanged)="onSelectionChanged()"
      (sortChanged)="onSortChanged($event)"
      (rowDataUpdated)="onRowDataUpdate()"
      (cellKeyDown)="onCellKeyDown($event)"
      (cellEditingStopped)="onCellEditingStopped($event)"
    >
    </ag-grid-angular>
  </ng-template>

  <app-grid-pagination
    *ngIf="pagination?.total_pages"
    [pagination]="pagination"
    (pageChange)="onPageChange($event)"
  ></app-grid-pagination>
</div>
